<template>
  <div class="kw_weekly_calendar">
    <div class="weeklyCalendarTitle">
      <img src="../list/img/left_arrow.png" alt="左" class="leftArrow" @click="lastWeek" />
      <span>{{timeBean.yearMonth}}</span>
      <img src="../list/img/right_arrow.png" alt="右" class="rightArrow" @click="nextWeek" />
    </div>
    <div class="weeklyCalendar">
        <div class="defaultAll" v-for="(item,index) in timeBean.weekDayList" :key="item.day">
          <div class="default">{{item.week}}</div>
          <div class="positionLocation" :class="currentDate == item.day?'checkData':'default' "  @click="dayClick(1,item.day,item.week)">{{item.day}}<span class="curriculumNumber" v-if="item.dayData!=null && item.dayData.length>0">{{item.dayData.length}}</span></div>
        </div>
    </div>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_weekly_calendar',
  props: {
    //树的数据内容
    value: {
      type: Object,
      default:function () {
          return {
            
          }
        }
    },
    // 第几个搜索字段
    index:{
      type:Number,
      value:0
    },
    htPageDataInfo:{
      type: Array,
      value: [],
      observer: 'changeHtData'
    }
  },
  data() {
    return {
      chooseMonth: '', // 选择查看月份
      timeBean: {},
      currentDate:'',
      selectWeek:0,
      a:0
    };
  },
  created() {
    console.log(this.htPageDataInfo)
    var _this = this;
    _this.timeBean = _this.getWeekDayList(0)
    if (_this.timeBean) {
      _this.timeBean = _this.timeBean;
      _this.currentDate = new Date().getDate();
    }
    this.dayClick(0, _this.timeBean, this.selectWeek)
  },
  mounted() {
    
  },
  watch:{
    htPageDataInfo() {
      console.log("htPageDataInfo===========watch====================");
      this.changeHtData();
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    changeHtData() {
      var val = this.htPageDataInfo;
      if (val && val.length>0) {
        var dataDayJson = {};
        val.forEach(one=>{
          var arr = dataDayJson['day_'+one.DAY];
          if(!arr) {
            arr = [];
            dataDayJson['day_' + one.DAY] = arr;
          }
          arr.push(one);
        })
        var timeBean = this.timeBean;
        var weekDayList = timeBean.weekDayList;
        if (weekDayList && weekDayList.length > 0) {
          weekDayList.forEach(one=>{
            var tmpDay = one.day < 10 ? '0' + one.day:one.day;
            // one.dayData = dataDayJson['day_' + tmpDay] ? dataDayJson['day_' + tmpDay]:[];
            this.$set(one,"dayData",dataDayJson['day_' + tmpDay] ? dataDayJson['day_' + tmpDay]:[]);
          })
        }
        // 调用切换列表的数据显示内容
        var nowShowData = dataDayJson['day_' + this.currentDate];
        if (!nowShowData) {
          nowShowData = [];
        }
        this.timeBean = timeBean;
      }
    },
    /**
     * 选中了某一日，改变selectDay为选中日
     */
    dayClick: function (e,data,i) {
      // console.log("日点击===============",e,data,i);
      if(e==0){
        var nowDay = new Date().getDate();
        var a = nowDay+(i*7)
        var currentDate;
        data.weekDayList.forEach(a=>{
          if (a.week == '一'){
           currentDate = a.day
          }
          if (a.day == nowDay) {
            currentDate = nowDay
          }
        })
        this.timeBean = data;
        this.currentDate = currentDate;
      }else{
        this.currentDate = data
      }
      this.setShowDataFilter();
    },
    /**
     * 触发列表页面的数据过滤
     */
    setShowDataFilter(){
      //设置过滤条件为 年月日 进行点击的搜索内容切换
      var tmpDay = this.currentDate < 10 ? '0' + this.currentDate : this.currentDate;
      var childE = {
        "DAY": tmpDay
      }
      console.log(childE)
//      this.triggerEvent("setShowDataFilter", childE);
      this.$emit('setShowDataFilter',childE)
    },

    /**
   * 点击上一周，调用getWeekDayList方法获取上一周数据
   */
    lastWeek: function () {
      var selectWeek = this.selectWeek;
      selectWeek--;
      this.selectWeek = selectWeek;
      // console.log(this.data.selectWeek)
      var timeBean = this.getWeekDayList(this.selectWeek)
      this.dayClick(0, timeBean, this.selectWeek)
      this.bindElementChange(timeBean);
    },
    /**
     * 点击下一周，调用getWeekDayList方法获取下一周数据
     */
    nextWeek: function () {
      var selectWeek = this.selectWeek;
      selectWeek++;
      this.selectWeek = selectWeek;
      var timeBean = this.getWeekDayList(this.selectWeek);
      this.dayClick(0, timeBean, this.selectWeek);
      this.bindElementChange(timeBean);
    },
    bindElementChange(timeBean){
      // var timeBean = this.data.timeBean;
      var startDate = pageUtils.dateFormat(timeBean.minDay,'yyyy-MM-dd');
      var endDate = pageUtils.dateFormat(timeBean.maxDay,'yyyy-MM-dd');
      this.value.startDate = startDate;
      this.value.endDate = endDate;
      this.$emit("bindElementChangeNextLoad");
    },
    /**
   * 获取该周的所要显示的周和日期的对应数据
   * var weekDay = {week: '',day: ''}
   * 参数：selectWeek  0为当前时间，-1为时间向前推一周，1则向后加一周
   * 参数：choosedTimeStamp  选择的月份的第一天的时间戳
   */
    getWeekDayList(selectWeek) {
      // 1.获取周一对应得时间
      // 2.循环一周添加周一到周日对应得周几和几号
      var timestamp = new Date().getTime() + (selectWeek * 7) * 24 * 60 * 60 * 1000;
      var selectWeekTime = timestamp
      var mondayTime = selectWeekTime - ((new Date(selectWeekTime).getDay() == 0 ? 7 : new Date(selectWeekTime).getDay()) - 1) * 24 * 60 * 60 * 1000
  
      var timeBean = {
        yearMonth: '',
        weekDayList: []
      }
      var weekList = ['一', '二', '三', '四', '五', '六', '日']
      var minDay = 0;
      var maxDay = 0;
      for (var i = 0; i < 7; i++) {
        var tmpDate = new Date((mondayTime + i * 24 * 60 * 60 * 1000));
        var tmpDay = tmpDate.getDate();
        var weekDay = {
          week: weekList[i],
          day: tmpDay,
        }
        if (i == 0) {
          minDay = tmpDate;
        }
        if (i == 6) {
          maxDay = tmpDate;
        }
        timeBean.weekDayList.push(weekDay)
      }

      // timeBean.yearMonth = this.getYearMonth(selectWeekTime);
      var time = new Date(selectWeekTime);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      timeBean.yearMonth = y + "年" + m + "月";
      timeBean.minDay = minDay;
      timeBean.maxDay = maxDay;
      console.log("timeBean===================", timeBean);
      return timeBean;
    },

    //时间戳获得年月
    getYearMonth(res) {
      var time = new Date(res);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      return y + "年" + m + "月";
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .weeklyCalendarTitle{font-size: 16px;padding: 5px 0;background: #FEEDE5;border-top-left-radius: 10px;border-top-right-radius: 10px;font-weight: bold;color: #EF3C00;display: flex;align-items: center;justify-content: center;}
  .weeklyCalendar{display: flex;flex-wrap: wrap;background: #FFFBF0;font-size: 14px;justify-content: space-around;padding: 20px 0}
  .defaultAll div{margin: 5px 0}
  /* 选中的日期 */
  .checkData{width: 30px;height: 30px;border-radius: 50%;background: #FF7A04;color: #ffffff;text-align: center;line-height: 30px}
  .default{width: 30px;border-radius: 50%;text-align: center;line-height: 30px;height: 35px;}

  .leftArrow ,.rightArrow{width: 20px;height: 20px;margin: 0 15px;}

  .positionLocation{position: relative}
  .curriculumNumber{position: absolute;right: -5px;top: -5px;background: #FCD8CC;color: #E86012;width: 16px;height: 16px;border-radius: 16px;text-align: center;line-height: 16px;font-size: 12px}
</style>
